import { useMemo } from 'react'
import { motion } from 'framer-motion'
import { useSearchParams } from 'react-router-dom'
import PlansSelectionView from '../../components/PlansSelectionView'

function PlanCheckoutUser() {
  const [searchParams] = useSearchParams()
  const tab = searchParams.get('tab')
  const returnTo = searchParams.get('returnTo')
  const defaultReturnPath = '/'
  const normalizedReturnPath = (() => {
    if (!returnTo) return defaultReturnPath

    try {
      const url = new URL(returnTo, window.location.origin)

      if (url.origin !== window.location.origin) {
        return defaultReturnPath
      }

      return `${url.pathname}${url.search}${url.hash}` || defaultReturnPath
    } catch {
      return defaultReturnPath
    }
  })()

  const returnUrl = useMemo(
    () => new URL(normalizedReturnPath, window.location.origin).toString(),
    [normalizedReturnPath],
  )

  const initialTab =
    tab === 'pacotes' || tab === 'packages' ? 'packages' : 'plans'

  return (
    <motion.div
      initial={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      style={{ height: '100%' }}
    >
      <PlansSelectionView
        showCancelAccount={true}
        showBackButton={true}
        returnUrl={returnUrl}
        backUrl={normalizedReturnPath}
        showPackagesTab={true}
        variant="checkout-user"
        initialTab={initialTab}
      />
    </motion.div>
  )
}

export default PlanCheckoutUser
